/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import { Platform } from 'react-native';
import type { NativeStackNavigationOptions } from '@react-navigation/native-stack';
import { ticketColors } from '../../shared/theme/ticketColors';
import {
  APP_HEADER_ACTIONS_RAIL_WIDTH,
  OperationalHeaderTitle,
} from './AppOperationalHeader';

export const HeaderTitle = OperationalHeaderTitle;

/** Márgenes del título en modales root (BranchSelector, etc.). */
export function getSharedAppHeaderOptions() {
  const isWeb = Platform.OS === 'web';

  return {
    headerStyle: { backgroundColor: ticketColors.paper },
    headerTintColor: ticketColors.ink,
    headerTitleAlign: 'left' as const,
    headerShadowVisible: false,
    headerTitleContainerStyle: {
      left: 16,
      right: APP_HEADER_ACTIONS_RAIL_WIDTH,
      maxWidth: '100%' as const,
      ...(isWeb
        ? {}
        : {
            top: 0,
            bottom: 0,
            justifyContent: 'center' as const,
          }),
    },
    headerRightContainerStyle: {
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      paddingLeft: 0,
      paddingRight: 0,
    },
    ...(isWeb ? { headerStatusBarHeight: 0 as const } : {}),
  };
}

/** Configuración y soporte: header compacto (sin sucursal en título). */
export function getProfileDrillDownHeaderOptions(): Pick<
  NativeStackNavigationOptions,
  'headerShadowVisible' | 'headerBackButtonDisplayMode'
> {
  return {
    headerShadowVisible: false,
    ...(Platform.OS === 'ios' ? { headerBackButtonDisplayMode: 'minimal' as const } : {}),
  };
}

export function resolveHeaderTitleLabel(children: unknown, fallback = 'Vuelto Negocio'): string {
  const text = children ? String(children).trim() : '';
  return text || fallback;
}

